// import React from "react";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import ScrollFloat from "../component/ScrollFloat";
import { Helmet } from "react-helmet";
import ImageWithSkeleton from "../component/ImageWithSkeleton";

export default function CryptoCurrency() {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleItem = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const splitTextToSpans = (text, className = "") =>
        [...text].map((char, index) => (
            <span className={`char ${className}`} key={`${char}-${index}`}>
                {char === " " ? "\u00A0" : char}
            </span>
        ));


    // light dark change image

    const [theme, setTheme] = useState("light");

    useEffect(() => {
        const currentTheme =
            document.documentElement.getAttribute("data-theme") || "light";
        setTheme(currentTheme);

        const observer = new MutationObserver(() => {
            const newTheme =
                document.documentElement.getAttribute("data-theme") || "light";
            setTheme(newTheme);
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["data-theme"],
        });

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <Helmet>
                <title>Cryptocurrency Development Services | Blockcryp</title>
                <meta
                    name="description"
                    content="Launch your own cryptocurrency with Blockcryp. We offer secure coin and token development, blockchain integration, and custom crypto solutions for businesses."
                />
                <meta
                    name="keywords"
                    content=" cryptocurrency development services, crypto coin development, token development company, custom cryptocurrency solutions, crypto development company, blockchain-based currency development, cryptocurrency integration services, crypto token creation, altcoin development services, blockchain crypto developers"
                />
            </Helmet>
            {/* ---------- hreo section start ---------- */}
            <section className="space80">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 oreder-lg-1 order-2">
                            <motion.h1
                                className="heading_h1 fw-semibold"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            > <span className="text-primary fw-bold"> Cryptocurrency </span> Exchange Development
                            </motion.h1>
                            <motion.p
                                className="pera_txt"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Unlock the future of finance with our <b> Cryptocurrency Exchange Development Company. </b> Empower your business with advanced crypto exchange solutions customised to your needs. Designed for security, speed, and ease of use, Blockcryp allows you to trade digital assets confidently. Whether you’re a beginner or an expert, we’ve got you covered. Start your cryptocurrency exchange journey today!</motion.p>
                            <motion.button
                                className="button theme_btn px-lg-4 mt-0 mt-lg-3" type="submit"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Launch Your Exchange</motion.button>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/cryptocurrency/crypto_hero2.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/cryptocurrency/crypto_hero.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="space80 services">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-xl-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/cryptocurrency/sercrypto1.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/cryptocurrency/sercrypto1.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-xl-6">
                            <div>
                                <motion.h3
                                    className="heading_h3 fw-semibold"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Delivering New-Gen Crypto Exchange Development Services
                                </motion.h3>
                                <motion.p
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >The Titans are already in. If you’re still on the fence, you’re signing up for a one-way trip to the past. As wait-and-watch is over, it’s time for you to step into the digital, transparent and open economy. Blockcryp, the best crypto exchange development company, builds the foundation for platforms that rise to the throne.</motion.p>
                                <motion.p
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >At Blockcryp, we have the top 1% of talent on board with us to ensure that you launch multi-chain trading empires that move ahead of the competition with extraordinary features and integrations. Our team of experienced fintech consultants and certified engineers draws on its wealth of experience and know-how to offer futuristic crypto exchange development solutions that deliver a distinctive customer experience.</motion.p>
                                <div className="d-flex justify-content-lg-start justify-content-center flex-wrap">
                                    <motion.ul
                                        className="safety-list pe-lg-3 pe-0"
                                        initial={{ opacity: 0, x: 50 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 1, delay: 0.5 }}
                                        viewport={{ once: false, amount: 0.5 }}
                                    >
                                        <li className="p-2"><i className="bi bi-check-circle-fill me-2"></i>7+ Years of Blockchain Supremacy</li>
                                        <li className="p-2"><i className="bi bi-check-circle-fill me-2"></i>Modern Coding Techniques</li>
                                        <li className="p-2"><i className="bi bi-check-circle-fill me-2"></i>In-house design and Development</li>
                                    </motion.ul>
                                    <motion.ul
                                        className="safety-list"
                                        initial={{ opacity: 0, x: 50 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 1, delay: 0.5 }}
                                        viewport={{ once: false, amount: 0.5 }}
                                    >
                                        <li className="p-2"><i className="bi bi-check-circle-fill me-2"></i>First-Time Right Deliverables</li>
                                        <li className="p-2"><i className="bi bi-check-circle-fill me-2"></i>Post-Development Support</li>
                                        <li className="p-2"><i className="bi bi-check-circle-fill me-2"></i>Mission-driven, Bespoke Services</li>
                                    </motion.ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Crypto Business section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-12 mb-3">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h4 fw-semibold text-center"
                            >
                                Advanced Crypto Exchange Development Models <br className="d-md-block d-none" />  to Scale Your Crypto Business
                            </ScrollFloat>
                            {/* <h2 className="heading_h3 fw-semibold text-center">Advanced Crypto Exchange Development Models to Scale Your Crypto Business</h2> */}
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-semibold">Order Book Crypto Exchange</h5>
                                <p>Build a high-performance order book exchange with real-time data processing, ensuring accurate trade execution, deep liquidity, and a seamless user trading experience.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-semibold">Peer To Peer Crypto Exchange</h5>
                                <p>Create a decentralized, user-friendly P2P crypto exchange enabling direct trading with privacy, security, and control, eliminating the need for third-party intermediaries.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-semibold">Derivative Exchange</h5>
                                <p>Launch a powerful derivatives exchange for trading futures and options, offering leverage, risk management tools, and a full-featured, professional trading environment.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-semibold">OTC Crypto Exchange</h5>
                                <p>Develop an OTC platform for large crypto trades with private, secure transactions designed for institutions and high-net-worth individuals seeking minimal market impact.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-semibold">Custodial Wallet Integration</h5>
                                <p>Offer custodial wallets to users, simplifying crypto storage with secure, platform-managed wallets that ensure safety, accessibility, and trusted asset management.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-semibold">Non-Custodial Wallet</h5>
                                <p>Support non-custodial wallets on your exchange, granting users full control of private keys and assets while ensuring top-tier security and decentralized fund management.</p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ---------- Exchange Development Services section start ---------- */}
            <section className="space60">
                <div className="container">
                    {/* <h2 className="heading_h3 fw-bold text-center mb-5">Our Premium Cryptocurrency <span className="text-primary">Exchange Development Services</span></h2> */}
                    <div className="row align-items-center g-4">
                        <div className="col-12">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-semibold text-center mb-5"
                            >
                                <>
                                    {splitTextToSpans(" Our Premium Cryptocurrency Exchange")} <br className="d-md-block d-none" />
                                    {splitTextToSpans(" Development Services", "text-primary")}
                                </>
                            </ScrollFloat>
                        </div>
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h3
                                className="heading_h3 fw-semibold mb-4"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Custom Exchange Development</motion.h3>
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Advanced Security Protocols :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Security is at the core of our development. We implement multi-layered security features such as DDoS protection, end-to-end encryption, cold wallet integration, and multi-factor authentication to keep user assets and data safe from potential breaches and cyber threats.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >User-Centric Experience :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We design interfaces with intuitive dashboards, real-time order books, and smooth navigation for traders. Our exchanges support multiple trading pairs, fiat integration, and responsive design to offer users a seamless and engaging trading experience across all devices.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Tailored Exchange Architecture :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We develop custom exchange platforms with a flexible architecture tailored to your business model, target audience, and scalability needs. Our modular approach ensures easy updates and integrations, giving you complete control over your platform’s growth and features.
                                </motion.p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/cryptocurrency/sercrypto2.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/cryptocurrency/sercrypto2.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- White Paper Consultation section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/cryptocurrency/sercrypto33.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/cryptocurrency/sercrypto3.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <div>
                                <motion.h3
                                    className="heading_h3 fw-bold mb-4"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Crypto Exchange Consulting</motion.h3>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Regulatory Guidance :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Navigating regulations can be complex. Our experts offer detailed advice on licensing, jurisdiction selection, and AML/KYC compliance. We help you avoid legal pitfalls and set up your crypto exchange in a compliant and sustainable manner from day one.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Technical Roadmapping :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    From selecting the right tech stack to infrastructure planning, we assist in creating a full project blueprint. We help clients understand hardware, software, and security requirements for building a stable, high-performing crypto exchange tailored to their goals.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Comprehensive Market Analysis :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We guide clients through crypto market dynamics by analyzing trends, user behavior, and competitor benchmarks. Our research-backed consultation helps define your exchange’s unique selling proposition and align it with your business goals for maximum traction.
                                </motion.p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Crypto Listing Services section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h3
                                className="heading_h3 fw-semibold mb-4"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >White Label Exchange</motion.h3>
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >All-in-One Functionality :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    White label platforms come integrated with KYC/AML modules, order books, wallets, admin panels, and more. These ready-to-deploy features ensure you can operate a professional, secure exchange platform that’s equipped to handle diverse trading scenarios.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Future-Proof Scalability :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Built with scalability in mind, our white label exchanges support easy upgrades. Whether it’s adding tokens, expanding user base, or integrating advanced trading tools, our solution grows with your business without compromising performance or security.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Quick Launch & Branding :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Our white label solution allows you to launch your own branded crypto exchange in record time. The platform is fully customizable, enabling you to apply your logo, brand colors, and preferred features while skipping the complexities of development from scratch.
                                </motion.p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/cryptocurrency/sercrypto4.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/cryptocurrency/sercrypto4.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Token Migration Services section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/cryptocurrency/sercrypto55.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/cryptocurrency/sercrypto5.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <div>
                                <motion.h3
                                    className="heading_h3 fw-bold mb-4"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Crypto Payment Gateway</motion.h3>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Multi-Currency Support :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Our crypto payment gateway supports a wide range of cryptocurrencies like BTC, ETH, USDT, and more. Businesses can accept payments in multiple tokens, allowing global customers to pay conveniently and securely while simplifying cross-border transactions.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Cross-Industry Integration :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We integrate gateways into industries such as e-commerce, iGaming, DeFi, and NFT platforms. Our custom APIs and plugins make it easy to connect with your platform, enabling instant, secure payments while reducing reliance on traditional financial systems.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Enhanced Security & Compliance :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Security is built into the foundation with encrypted transactions, fraud detection, and AML checks. We ensure PCI-DSS compliance and offer secure wallet integration to guarantee safe processing of crypto payments across various platforms and regions.
                                </motion.p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Non-Fungible Tokens section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h3
                                className="heading_h3 fw-semibold mb-4"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Cryptocurrency Legal Solution</motion.h3>
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Global Regulatory Expertise :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Our legal experts provide support in meeting the regulatory standards of jurisdictions around the world. We help you identify the most favorable regions to register and operate your exchange while minimizing legal risks and ensuring business continuity.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Licensing & Documentation :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We support a wide range of cryptocurrencies and ensure seamless performance under high-volume transactions. Our system is fortified with end-to-end security, including multi-factor authentication, advanced encryption, and robust anti-fraud mechanisms to ensure safety at every level of operation.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Compliance & Risk Management :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Our legal team monitors evolving regulations and ensures your platform stays compliant. We help develop risk mitigation strategies, ensuring your business remains agile, protected, and capable of withstanding compliance audits and investigations.
                                </motion.p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/cryptocurrency/sercrypto66.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/cryptocurrency/sercrypto6.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Token Migration Services section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/cryptocurrency/sercrypto77.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/cryptocurrency/sercrypto7.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <div>
                                <motion.h3
                                    className="heading_h3 fw-bold mb-4"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Integration Services & Solutions</motion.h3>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Crypto Gateway Integration :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We specialize in integrating crypto payment gateways into existing exchange platforms. This enhances transactional capabilities, allowing users to deposit, withdraw, and transact in various cryptocurrencies easily, securely, and with minimal processing delays.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Custom Feature Implementation :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Need a new trading pair, liquidity provider, or wallet system? We offer tailored integrations to expand your platform’s capabilities. Our team adds new modules without disrupting current operations, ensuring users enjoy seamless functionality and performance.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Seamless transaction management :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Whether it’s integrating with analytics tools, market data feeds, or external KYC providers, we facilitate smooth API integrations. Our services ensure that every new feature you add complements the system without affecting its speed, uptime, or user experience.
                                </motion.p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="space60 services">
                <div className="container">
                    <div className="row justify-content-center g-4">
                        <div className="col-xl-9 col-12 mb-5">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-semibold text-center"
                            >
                                Boost Your Bottom-Line With Best Cryptocurrency <br className="d-md-block d-none" /> Exchange Development Services
                            </ScrollFloat>
                            {/* <h2 className="heading_h3 fw-semibold text-center">Boost Your Bottom-Line With Best Cryptocurrency Exchange Development Services</h2> */}
                            <motion.p
                                className="text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Whether you represent a sizable, highly regulated fintech institution, a digital currency startup, or an innovative tech investor, our crypto exchange development services have everything you need:</motion.p>
                        </div>
                    </div>
                    <div className="row justify-content-center g-4">
                        <div className="col-xl-4 col-md-6">
                            <motion.div
                                className="crypto_card text-center h-100"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/cryptocurrency/sericon1-dark.svg"
                                            : "assets/images/cryptocurrency/sericon1-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold">Crypto Exchange Consulting</h5>
                                <p>New to crypto? Our top-notch consulting services tailored for first-timers turn first steps into power moves, smoothing the on-ramp to your crypto journey.
                                </p>
                            </motion.div>
                        </div>
                        <div className="col-xl-4 col-md-6">
                            <motion.div
                                className="crypto_card text-center h-100"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/cryptocurrency/sericon2-dark.svg"
                                            : "assets/images/cryptocurrency/sericon2-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold">Custom Exchange Development</h5>
                                <p>AI-enhanced cryptocurrency exchange software development engineered to the specifications and secured to the core.
                                </p>
                            </motion.div>
                        </div>
                        <div className="col-xl-4 col-md-6">
                            <motion.div
                                className="crypto_card text-center h-100"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/cryptocurrency/sericon3-dark.svg"
                                            : "assets/images/cryptocurrency/sericon3-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold">White Label Exchange Development</h5>
                                <p>You’ve got the vision. We’ve got the script. Launch smarter with scalable white label crypto exchange software development solutions.
                                </p>
                            </motion.div>
                        </div>
                        <div className="col-xl-4 col-md-6">
                            <motion.div
                                className="crypto_card text-center h-100"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/cryptocurrency/sericon4-dark.svg"
                                            : "assets/images/cryptocurrency/sericon4-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold">Integration Services & Maintenance</h5>
                                <p>New features, complete overhauls or maintenance—we fine-tune your crypto exchange software development with precision so it keeps up with your ambition.
                                </p>
                            </motion.div>
                        </div>
                        <div className="col-xl-4 col-md-6">
                            <motion.div
                                className="crypto_card text-center h-100"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/cryptocurrency/sericon5-dark.svg"
                                            : "assets/images/cryptocurrency/sericon5-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold">Arbitrage Bot Development</h5>
                                <p>Designed by top-notch blockchain experts and powered by intelligence, our arbitrage bots do the heavy lifting so you stay ahead.
                                </p>
                            </motion.div>
                        </div>
                        <div className="col-xl-4 col-md-6">
                            <motion.div
                                className="crypto_card text-center h-100"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/cryptocurrency/sericon6-dark.svg"
                                            : "assets/images/cryptocurrency/sericon6-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold">AI-Powered Crypto Exchange Development</h5>
                                <p>Smarter exchanges win. Build an AI-powered crypto exchange software that thinks, adapts and scales, and unlock 10X customer acquisition and retention.
                                </p>
                            </motion.div>
                        </div>
                        <div className="col-xl-4 col-md-6">
                            <motion.div
                                className="crypto_card text-center h-100"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/cryptocurrency/sericon7-dark.svg"
                                            : "assets/images/cryptocurrency/sericon7-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold">Cryptocurrency Prediction Market Development</h5>
                                <p>Enable the thrill-seeker speculative enthusiast to bet on the future. Build the AI-powered cryptocurrency prediction marketplace of tomorrow.
                                </p>
                            </motion.div>
                        </div>
                        <div className="col-xl-4 col-md-6">
                            <motion.div
                                className="crypto_card text-center h-100"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/cryptocurrency/sericon8-dark.svg"
                                            : "assets/images/cryptocurrency/sericon8-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold">Cryptocurrency Legal Solutions</h5>
                                <p>Regulations change. Your exchange won’t flinch. Our cryptocurrency exchange platform development company, armed with an experienced team of attorneys, got the legal edge.
                                </p>
                            </motion.div>
                        </div>
                        <div className="col-xl-4 col-md-6">
                            <motion.div
                                className="crypto_card text-center h-100"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/cryptocurrency/sericon9-dark.svg"
                                            : "assets/images/cryptocurrency/sericon9-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold">Crypto Payment Gateway Integration</h5>
                                <p>Groceries, jewelry, e-commerce, gas & even card giants—crypto payments are everywhere. Get ready with a gateway that accepts NFTs, tokenized RWAs, stablecoins and crypto.
                                </p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ---------- faq section start ---------- */}
            <section className="space60">
                <div className="container">
                    <h2 className="heading_h3 fw-bold mb-4">Frequently Asked Questions</h2>
                    <div className="row">
                        <div className="col-12">
                            <div className="accordion">
                                <div className={`accordion__item ${activeIndex === 0 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(0)}>
                                        <span className="text_20 pe-4">
                                            1. Can I launch a white-label crypto exchange?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Yes, white-label crypto exchanges offered by us provide a faster, cost-efficient path to market. These pre-built platforms come with core trading modules, wallet integration, and customizable UI, enabling startups to focus on branding and liquidity without building everything from scratch.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 1 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(1)}>
                                        <span className="text_20 pe-4">
                                            2. How long does it take to develop a crypto exchange?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Building a crypto exchange can take 3 to 9 months, depending on complexity. A basic MVP may take 12–16 weeks, while full-featured platforms with KYC, wallets, trading engines, and admin dashboards require more rigorous design, testing, and deployment time.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 2 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(2)}>
                                        <span className="text_20 pe-4">
                                            3. How do I ensure scalability for my exchange platform?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Scalability is achieved through microservices architecture, cloud infrastructure (like AWS/GCP), load balancing, and high-performance databases. We build with future growth in mind, ensuring your platform handles thousands of concurrent trades securely and smoothly.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 3 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(3)}>
                                        <span className="text_20 pe-4">
                                            4. How long does it take to build a blockchain application?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            A robust crypto exchange development typically involves reliable technologies like React or Angular for the frontend, Node.js or Python for the backend, PostgreSQL or MongoDB for data, Web3.js, Ethereum, or Binance Smart Chain for blockchain integration, and Redis for real-time trading systems
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 4 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0 " onClick={() => toggleItem(4)}>
                                        <span className="text_20 pe-4">
                                            5. What security features are must-haves for a crypto exchange?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Key security elements include cold wallet integration, 2FA, end-to-end encryption, anti-DDoS protection, KYC/AML modules, smart contract audits, and transaction monitoring. Multi-layer security protects user funds and prevents breaches or regulatory non-compliance.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
